import Rails from '@rails/ujs';
import autosize from 'autosize';
import AccessibleAutocomplete from 'accessible-autocomplete';

Rails.start();

document.addEventListener('DOMContentLoaded', function() {
  const checkboxLinkers = document.querySelectorAll('[data-module="checkbox-linker"]');
  Array.prototype.slice.call(checkboxLinkers).forEach(function(element) {
    const isAutoSubmitEnabled = element.getAttribute('data-autosubmit') == 'true';

    Array.prototype.slice.call(element.querySelectorAll('input[type="checkbox"]')).forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        const linkedCheckboxes = element.querySelectorAll("input[value='" + this.value + "']");

        Array.prototype.slice.call(linkedCheckboxes).forEach(function(linkedCheckbox) {
          if (linkedCheckbox !== checkbox) {
            linkedCheckbox.checked = checkbox.checked;
          }
        });

        if (isAutoSubmitEnabled) {
          checkbox.form.submit();
        }
      });
    });
  });

  const collapsibleNavigations = document.querySelectorAll('[data-module="collapsible-navigation"]');
  Array.prototype.slice.call(collapsibleNavigations).forEach(function(element) {
    const connectedControlSelector = element.getAttribute('data-control-selector');
    const connectedControls = document.querySelectorAll(connectedControlSelector);

    connectedControls.forEach(function(control) {
      control.addEventListener('click', function(event) {
        if (element.classList.contains('is-visible')) {
          element.classList.remove('is-visible');
          connectedControls.forEach(function(_control) { _control.classList.remove('is-active'); });
        } else {
          element.classList.add('is-visible');
          connectedControls.forEach(function(_control) { _control.classList.add('is-active'); });
        }
      });
    });
  });

  const COLLAPSIBLE_TREE_COLLAPSED_CSS_CLASS = 'collapsible-tree__node--collapsed';
  const collapsibleTrees = document.querySelectorAll('[data-module="collapsible-tree"]');
  Array.prototype.slice.call(collapsibleTrees).forEach(function(tree) {
    const nonLeafNodes = tree.querySelectorAll('[data-role="tree-branch"]');
    Array.prototype.slice.call(nonLeafNodes).forEach(function(branch) {
      const handle = branch.querySelector('[data-action="toggle-node"]');

      handle.addEventListener('click', function(event) {
        if (branch.classList.contains(COLLAPSIBLE_TREE_COLLAPSED_CSS_CLASS)) {
          branch.classList.remove(COLLAPSIBLE_TREE_COLLAPSED_CSS_CLASS);
        } else {
          branch.classList.add(COLLAPSIBLE_TREE_COLLAPSED_CSS_CLASS);
        }
      });

      const checkedCheckboxes = branch.querySelectorAll('input[type="checkbox"]:checked');
      if (checkedCheckboxes.length === 0) {
        branch.classList.add(COLLAPSIBLE_TREE_COLLAPSED_CSS_CLASS);
      }
    });
  });

  const autosizableTextareas = document.querySelectorAll('[data-module="autosize"]');
  Array.prototype.slice.call(autosizableTextareas).forEach(function(element) {
    // Without the timeout the textareas are autosized too tall at the initial page load.
    // The suspicion is that slow stylesheets are the reason.
    setTimeout(function() {
      autosize(element);
    }, 100);
  });

  const FORM_GROUP_INPUT_CLASS = 'form-group__input';
  const FORM_GROUP_OPTIONS_CLASS = 'form-group__options';
  const enhancedSelects = document.querySelectorAll('[data-module="enhanced-select"]');
  Array.prototype.slice.call(enhancedSelects).forEach(function(element) {
    const isMultiple = element.multiple;
    const elementId = element.getAttribute('id');
    element.setAttribute('id', `${elementId}-select`);
    element.style.display = 'none';

    const container = element.parentNode;

    const selectOptionElements = Array.prototype.slice.call(element.querySelectorAll('option'));
    const data = selectOptionElements.filter(function(option) {
      // Ignore options without value or with blank value
      return (option.value || '').trim().length !== 0;
    }).map(function(option) {
      return {
        label: option.innerText,
        value: option.value,
      };
    });

    const filterData = function(data, query, condition) {
      const lowercaseQuery = query.toLowerCase();

      return data.filter(function(result) {
        return result.label.toLowerCase().indexOf(lowercaseQuery) !== -1 && (condition === undefined || condition(result));
      });
    }

    const sharedConfiguration = {
      id: elementId,
      name: '',
      element: container,
      source: function suggest(query, populateResults) {
        populateResults(filterData(data, query));
      },
      displayMenu: 'overlay',
      templates: {
        inputValue: function(item) {
          return item ? item.label : undefined;
        },
        suggestion: function(item) {
          return item.label;
        },
      },
      tNoResults: function() {
        return 'Keine Ergebnisse';
      },
      tAssistiveHint: function() {
        return 'Wenn Ergebnisse für die automatische Vervollständigung verfügbar sind, nutzen Sie die Aufwärts- und Abwärtspfeiltasten um Optionen durchzusehen und die Enter-Taste um auszuwählen. Auf Touch-Geräten können Sie durch Berühren oder mit Wischgesten navigieren.';
      },
      tStatusQueryTooShort: function(minQueryLength) {
        return `Tippen Sie ${minQueryLength} oder mehr Zeichen ein um Ergebnisse zu erhalten`;
      },
      tStatusNoResults: function() {
        return 'Keine Suchergebnisse';
      },
      tStatusSelectedOption: function(selectedOption, length, index) {
        return `${selectedOption} ${index + 1} von ${length} ist hervorgehoben`;
      },
      tStatusResults: function(length, contentSelectedOption) {
        const words = {
          result: (length === 1) ? 'Ergebnis' : 'Ergebnisse',
          is: (length === 1) ? 'ist' : 'sind',
        }

        return `${length} ${words.result} ${words.is} verfügbar. ${contentSelectedOption}`;
      },
    };

    const updateSelectElement = function(value, optionElements) {
      selectOptionByValue(optionElements, value);
    }

    const clearInput = function(input) {
      const timeout = window.setTimeout(function() {
        input.value = '';
        input.dispatchEvent(new Event('input'));
      }, 1);
    }

    const selectOptionByValue = function(optionElements, value) {
      const option = optionElements.find(function(option) { return option.value === value; });
      option.selected = true;

      const selectElement = optionElements[0].parentNode;
      selectElement.dispatchEvent(new Event('change'));
    }

    const deselectOptionByValue = function(optionElements, value) {
      const option = optionElements.find(function(option) { return option.value === value; });
      option.selected = false;

      const selectElement = optionElements[0].parentNode;
      selectElement.dispatchEvent(new Event('change'));
    }

    const buildSelectedOptionsList = function(container, selectElement, optionElements) {
      const update = function(list, optionElements) {
        const optionsMarkup = optionElements.filter(function(option) {
          return option.selected;
        }).map(function(option) {
          const itemId = `${elementId}-option-${option.value}`;
          const showMoreUrl = option.getAttribute('data-show-more-url');
          let showMoreElement = '';

          if (showMoreUrl) {
            showMoreElement = `<a class="options-list__show-more" href="${showMoreUrl}">mehr erfahren</a>`;
          }

          return [
            `<li class="options-list__item">`,
              `<span class="options-list__control"><input type="checkbox" id="${itemId}" value="${option.value}" checked></span>`,
              `<label for="${itemId}">${option.innerText}</label>`,
              showMoreElement,
            `</li>`
          ].join('');
        }).join("\n");

        if (optionsMarkup.length > 0) {
          list.innerHTML = optionsMarkup;
          list.style.display = '';

          bindItems(list, optionElements);
        } else if (list.parentNode) {
          list.innerHTML = '';
          list.style.display = 'none';
        }
      }

      const bindItems = function(list, optionElements) {
        const checkboxes = list.querySelectorAll('input[type="checkbox"]');
        Array.prototype.slice.call(checkboxes).forEach(function(checkbox) {
          const handler = function(event) {
            event.stopPropagation();

            deselectOptionByValue(optionElements, checkbox.value);

            checkbox.removeEventListener('change', handler);
          }

          checkbox.addEventListener('change', handler);
        });
      }

      const list = document.createElement('ul');
      list.classList.add('options-list');
      list.classList.add(FORM_GROUP_OPTIONS_CLASS);
      container.insertBefore(list, container.children[0]);

      update(list, optionElements);

      selectElement.addEventListener('change', function(event) {
        update(list, optionElements);
      });
    }

    const buildToggleLink = function(container) {
      const link = document.createElement('a');
      link.href = '#';
      link.innerHTML = 'Alle Vorschläge anzeigen';
      container.appendChild(link);

      link.addEventListener('click', function(event) {
        container.querySelector('input').focus();
        container.querySelector('input').click();
      });
    }

    if (isMultiple) {
      const showToggle = element.getAttribute('data-show-all') === 'true';

      buildSelectedOptionsList(element.parentNode.parentNode, element, selectOptionElements);

      AccessibleAutocomplete(Object.assign(sharedConfiguration, {
        showAllValues: showToggle,
        source: function suggest(query, populateResults) {
          const selectedValues = selectOptionElements.filter(function(option) { return option.selected; }).map(function(option) { return option.value; })
          const matches = filterData(data, query, function(result) {
            return !selectedValues.includes(result.value);
          });

          populateResults(matches);
        },
        placeholder: element.getAttribute('data-placeholder'),
        onConfirm: function(result) {
          if (!result) { return; }

          updateSelectElement(result.value, selectOptionElements);
          clearInput(container.querySelector('input'));
        },
      }));

      if (showToggle) {
        buildToggleLink(container);
      }
    } else {
      const selectedOption = selectOptionElements.find(function(option) { return option.selected && option.value != ''; });
      const blankOption = selectOptionElements.find(function(option) { return option.value == ''; });
      const placeholder = blankOption ? blankOption.innerText : null;

      AccessibleAutocomplete(Object.assign(sharedConfiguration, {
        showAllValues: true,
        dropdownArrow: function() { return ''; },
        defaultValue: selectedOption ? selectedOption.label : '',
        placeholder: placeholder,
        onConfirm: function(result) {
          if (!result) { return; }

          updateSelectElement(result.value, selectOptionElements);
        },
      }));
    }

    container.querySelector('input').classList.add(FORM_GROUP_INPUT_CLASS);
  });
});

